module.exports = __webpack_public_path__ + "static/meditations-a9f2a23cc01cc49da04ff03bd21265c9.jpg";